// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.v-btn-toggle .v-btn[data-v-0722e07f] {\n  min-width: 140px;\n}\n\n/* Style für aktiven Button */\n.active-mode[data-v-0722e07f] {\n  background-color: #505673 !important; /* Vuetify Primary */\n  color: white !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important; /* Entfernt den Schlagschatten */\n}", ""]);
// Exports
module.exports = exports;
